'use client';

export const STACKADAPT_PIXEL_ID = process.env.NEXT_PUBLIC_STACKADAPT_PIXEL_ID;

export const STACKADAPT_EVENTS = {
    businessSignup: 'business_signup'
} as const;

export const pageview = () => {
    if ( !STACKADAPT_PIXEL_ID || typeof window?.saq === 'undefined' ) {
        return;
    }

    try {
        window.saq( 'ts', STACKADAPT_PIXEL_ID );
    } catch ( e ) {
        if ( e && e instanceof Error ) {
            console.error( `Error firing StackAdapt pageview - ${ e.message }` );
        }
    }
};

export const event = ( params: Record<string, string> ) => {
    if ( !STACKADAPT_PIXEL_ID || typeof window?.saq === 'undefined' ) {
        return;
    }

    try {
        window.saq( 'ts', STACKADAPT_PIXEL_ID, params );
    } catch ( e ) {
        if ( e && e instanceof Error ) {
            console.error( `Error firing StackAdapt event - ${ e.message }` );
        }
    }
};
